const globalURL = "https://love.kickeepants.com/shop/pc/KP_find_store_AJAX.asp" ;

class findStoreJs {
  constructor() {
    this.init();
  }

  hitApiCall = (queryValue) => {
    siteOverlay.prototype.showOverlay();
    document.querySelector('#PopupModal-waiting-storedata .modal').classList.add('open');
    
    fetch(globalURL, {
      method: 'POST',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "x-shopify-topic":"fas/get"
      },
      body: queryValue
    })
    .then(response => {
      return response.text();
    })
    .then((data) => {
        console.log(`data: `, data);
      if (data != null) {
        const innerHTML = new DOMParser().parseFromString(data, 'text/html');
        if (innerHTML.querySelector('main') != null) {
          data = innerHTML.querySelector('main').outerHTML;
        }
        document.querySelector('.form-response-wrapper.d-none').innerHTML = data;
        document.querySelector('.form-response-wrapper.d-none').classList.remove('d-none');
        document.querySelector('.form-store-wrapper').classList.add('d-none');
        var resetBtn = document.querySelector('.form-response-wrapper #resetForm');
        if (resetBtn != null) {
          resetBtn.addEventListener('click', function(e) {
            document.querySelector('.form-response-wrapper').innerHTML = '';
            document.querySelector('.form-response-wrapper').classList.add('d-none');
            document.querySelector('.form-store-wrapper').classList.remove('d-none');
          })
        }
      }
      siteOverlay.prototype.hideOverlay();
      document.querySelector('#PopupModal-waiting-storedata .modal').classList.remove('open');
    })
  }

  getOnlineStore = () => {
    const that = this;
    var onlineStores = document.querySelector('#onlineStores');
    if (onlineStores != null) {
      onlineStores.addEventListener('click', function (e) {
        that.hitApiCall('onlineSelected=1');
      })
    }
  }

  onStateChange = () => {
    const that = this;
    var stateBtn = document.querySelector('#stateSelect');
    if (stateBtn != null) {
      stateBtn.addEventListener('change', function(e) {
        that.hitApiCall(`stateSelected=${e.target.value}`);
      })
    }
  }

  onCountryChange = () => {
    const that = this;
    var countryBtn = document.querySelector('#countrySelect');
    if (countryBtn != null) {
      countryBtn.addEventListener('change', function(e) {
        that.hitApiCall(`countrySelected=${e.target.value}`);
      })
    }
  }

  init = () => {
    this.getOnlineStore(); 
    this.onStateChange();
    this.onCountryChange();
  }
}

new findStoreJs;